var styleDataHash = "227bbe9b";
const injectCss = (() => {
  var css = `.owxjE{height:18px;position:relative;width:18px}.D78er,.FLWJW{height:100%;left:0;position:absolute;top:0;width:100%;fill:none;stroke-linecap:round}.FLWJW{animation:KfH5N 666ms linear infinite;opacity:.3}.D78er,.FLWJW{stroke:currentColor}.D78er{animation:KfH5N 2s linear infinite}@keyframes KfH5N{to{transform:rotate(1turn)}}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var double_loader_default = {
  "wrapper": "owxjE",
  "top": "FLWJW",
  "bottom": "D78er",
  "rotation": "KfH5N"
};
export {
  double_loader_default as default,
  injectCss
};
//# sourceMappingURL=double-loader-scss.js.map
